import { ReactNode } from 'react';
import { AuthBrandPanel, BrandLink  } from '@auth';
import ExternalBackLink from '@/shared/components/ExternalBackLink';
import Footer from '@/shared/components/Footer';

interface Props {
  children: ReactNode;
}

export default function AuthLayout({ children }: Props) {
  return (
    <div className="min-h-screen min-h-[100dvh] bg-brand-950 lg:grid lg:grid-cols-[minmax(22rem,0.85fr)_minmax(34rem,1.15fr)]">
      <AuthBrandPanel />
      <div className="flex min-h-[100dvh] min-w-0 flex-col bg-slate-50">
        <main className="flex flex-1 items-center py-8">
          <div className="mx-auto w-full max-w-[440px] px-5 sm:px-0">
            <div className="flex items-center justify-between lg:justify-end">
              <div className="lg:hidden">
                <BrandLink tone="default" />
              </div>
              <ExternalBackLink />
            </div>
            <div className="mt-10">{children}</div>
          </div>
        </main>
        <Footer />
      </div>
    </div>
  );
}
